import React, { useEffect } from 'react';
import { HeroSection } from './components/HeroSection';
import { TruthSection } from './components/TruthSection';
import { MechanismSection } from './components/MechanismSection';
import { FeelingsSection } from './components/FeelingsSection';
import { IncludesSection } from './components/IncludesSection';
import { PainSection } from './components/PainSection';
import { NotForYouSection } from './components/NotForYouSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { PricingSection } from './components/PricingSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen w-full bg-cream text-text font-sans selection:bg-lavender selection:text-text-dark" data-id="element-0">
      <HeroSection data-id="element-1" />
      <TruthSection data-id="element-2" />
      <MechanismSection data-id="element-3" />
      <FeelingsSection data-id="element-4" />
      <IncludesSection data-id="element-5" />
      <PainSection data-id="element-6" />
      <NotForYouSection data-id="element-7" />
      <TestimonialsSection data-id="element-8" />
      <PricingSection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <Footer data-id="element-12" />
    </main>;
}